import React, {useState, useContext, useMemo} from "react";

import ReviewsList from "./ReviewsList.jsx";
import ReviewBottomLine from "./ReviewBottomLine.jsx";
import Pagination from "@components/general/Pagination.jsx";
import YotpoFilters from "./YotpoFilters.jsx"
import {YotpoContext} from '@contexts/YotpoContext.jsx';

const ReviewContainer = ({searchOptions}) => {

  const {reviews, loading, page, pages, setPage, totals, sorting, setSorting, scores, setScores, search, setSearch} = useContext(YotpoContext);

  const filters = <YotpoFilters sort={sorting} onSortChange={setSorting} search={search} onSearchChange={setSearch} searchOptions={searchOptions} />

  return (
    <div className="ft_yotpo__review-container page-width--large">
        <ReviewBottomLine totals={totals} scores={scores} setScores={setScores} filters={filters} />
        <ReviewsList reviews={reviews} loading={loading}/>
        <Pagination currentPage={page} pages={pages} setCurrentPage={setPage} loading={loading} />
    </div>
  );

}

export default ReviewContainer;
